import api from "./Api";

class PaisService {
  GetPaisOData(payload) {
    return api.get("/OData/Pais" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PaisService();
